import React from "react";
import PropTypes from "prop-types";

const Youtubeplayer = ({ embedId }) => (
  <div className="video-responsive">
    <iframe
      width="100%"
      height="320"
      src={`https://www.youtube.com/embed/${embedId}`}
      frameBorder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
      title="Embedded youtube"
    />
  </div>
);

Youtubeplayer.propTypes = {
  embedId: PropTypes.string.isRequired
};

export default Youtubeplayer;